module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAQCAYAAAAbBi9cAAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAALEgAACxIB0t1+/AAAABZ0RVh0Q3JlYXRpb24gVGltZQAwMi8yMS8xOSv5S6kAAAAfdEVYdFNvZnR3YXJlAE1hY3JvbWVkaWEgRmlyZXdvcmtzIDi1aNJ4AAAAt0lEQVQ4ja3RzQ2CQBCG4XeoCAN3QwdagVKBlqIVuFZgCbr3TaQUOhgPLFHCLn/yXTabfPMcZkRVIZcjcKOfK07PAORyAU6BTolTI5qxAx6BQpu7fw8Dnb1oxgvYDpSmxIpm6J8IAMkaSAvZFRybAGYFyIg//xtIFyIVTjftjkqgXoDUftYv22kFFDOxGij87M/V5mEdpAtNx3pIHxrHgkgYimNRBKA5fyy5pMDT/6LIOPTFGEIAPgiPUw9FoiROAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/yishoucang.png
// module id = YjPu
// module chunks = 1